import React, { Component } from "react";
import { observer } from "mobx-react";
import IconButton from '../../../comum/components/IconButton'
import moment from 'moment'
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";

@observer
export default class ExportarExcelAgServicos extends Component {
    constructor(props) {
        super(props);
        this.controller = this.props.controller;
        this.timeRegExp = new RegExp("([0-9]{4}\-[0-9]{2}\-[0-9]{2}T[0-9]{2}\:[0-9]{2}:[0-9]{2})")
    }

    _exporter;
    export = () => {
        this._exporter.save();
    };

    render() {
        let lista = [];
        if (this.controller.getLista().length > 0) { lista = this.controller.getListaCopia(); } else { lista = []; }
        let desabilita;
        if (lista.length > 0) {
            desabilita = false;
        } else {
            desabilita = true;
        }

        if (lista.length > 0) {
            lista.map(data => {
                const keys = Object.keys(data)
                keys.map(key => {
                    if(this.timeRegExp.test(data[key]) && moment(data[key]).format("DD/MM/YYYY HH:mm") !== 'Invalid date'){
                        data[key] = moment(data[key]).format("DD/MM/YYYY HH:mm")
                    }
                })
            })
        }

        let cols = this.controller.colunasExportacao
        return (
            <div>
                <IconButton icon="file-excel" text="Baixar XLS" size="md" disabled={desabilita} onClick={this.export} />

                <ExcelExport
                    data={lista}
                    fileName="AgendamentoServico.xlsx"
                    ref={(exporter) => { this._exporter = exporter; }} >
                    {cols.map((coluna, x) => (
                        <ExcelExportColumn
                            key={x}
                            title={coluna.text}
                            field={coluna.dataField}
                        />
                    ))}
                </ExcelExport>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamentoservicosTotal/visualizar/components/ExportarExcelAgServicos.js